import React from 'react'

function AIEndpoint() {
  return (
    <div>
Endpoint
    </div>
  )
}

export default AIEndpoint
